// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';
import {img_url} from '../ui/img_url';
import styles from './go_beyond_banner.module.less';
import {Install_btn} from '../ui/install_btn';
import {Editor} from '../../../shared/editor/editor';

interface i_go_beyond_banner_props {
    header: string;
    subheader: string;
    cta: string;
}

export const Go_beyond_banner = (props: i_go_beyond_banner_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.container}>
      <div className={styles.image_container}>
        <img src={img_url('hola2023/hero.svg')} alt="Hola hero picture" />
      </div>
      <div className={styles.text_container}>
        <h4 className={styles.header}>{props.header}</h4>
        <h5 className={styles.header}>{props.header}</h5>
        <p className={cn([theme.u3, theme.med])}>{props.subheader}</p>
        <Install_btn keep_btn_text text={props.cta}
          app_fixed="vpn" arrow
          className={cn('hola_btn hola_btn--md hola_btn--round',
          'hola_btn--txt_colored hola_btn--no_jump', styles.button)}/>
      </div>
    </div>;
};

interface i_go_beyond_banner_editor_props {
    value: i_go_beyond_banner_props;
    on_change: (new_val: i_go_beyond_banner_props)=>void;
}

export const Go_beyond_banner_editor =({value, on_change}:
i_go_beyond_banner_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'header', label: 'Header', type: 'text'},
        {key: 'subheader', label: 'Subheader', type: 'text'},
        {key: 'cta', label: 'CTA Button Text', type: 'text'},
      ]}/>;
};
